import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import queryString from 'query-string';
import {Checkbox} from 'rmwc';

import * as styles from '../../styles';
import {request} from '../../containers/actions';
import Note from '../book/note';
import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {refresh as paginatorRefresh, removeItem, clearSelection} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';


export default class Notes extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
    }

    style = {items: {itemsList: {table: {width: '100%'}}}}

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: item => `${item.author.firstname} ${item.author.lastname}`, label: window.gettext('Author')},
        {
            field: item => {
                const div = document.createElement('DIV');
                div.innerHTML = item.body;
                return div.innerText;
            },
            label: window.gettext('Text'),
            style: {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                maxWidth: '8em',
            },
        },
        {
            field: item => <div
                style={{
                    backgroundColor: item.confirmed && item.body === item.confirmed_body
                        ? styles.successBackColor
                        : item.confirmed || item.body === item.confirmed_body
                            ? styles.alertBackColor
                            : styles.warningBackColor,
                    color: item.confirmed && item.body === item.confirmed_body
                        ? styles.successColor
                        : item.confirmed || item.body === item.confirmed_body
                            ? styles.alertColor
                            : styles.warningColor,
                    borderColor: item.confirmed && item.body === item.confirmed_body
                        ? styles.successBorderColor
                        : item.confirmed || item.body === item.confirmed_body
                            ? styles.alertBorderColor
                            : styles.warningBorderColor,
                    textAlign: 'center',
                }}>
                {item.confirmed && item.body === item.confirmed_body
                    ? window.gettext('Confirmed')
                    : item.confirmed
                        ? window.gettext('Reconfirm')
                        : window.gettext('Not confirmed')
                }
            </div>,
            label: window.gettext('Confirmed'),
        },
        {field: 'subject', label: window.pgettext('note', 'Subject')},
        {field: item => item.type.label, label: window.pgettext('note', 'Type')},
        {field: item => item.timestamp.toJalali().persian(), label: window.gettext('Timestamp')},
        {field: item => item.chapter.book.grade.title, label: window.gettext('Grade')},
        {field: item => item.chapter.book.title, label: window.gettext('Book')},
        {field: item => item.chapter.caption, label: window.gettext('Chapter')},
        {
            field: item => <div>
                {item.likes.persian()}
                &nbsp;
                <i className='fa-lg fa-thumbs-o-up'></i>
                &nbsp;-&nbsp;
                {item.bookmarks.persian()}
                &nbsp;
                <i className='fa-lg fa-heart-o'></i>
                &nbsp;-&nbsp;
                {item.violation_reports.persian()}
                &nbsp;
                <i className='fa-lg fa-exclamation'></i>
            </div>,
            label: window.gettext('Social Feedback'),
        },
    ]

    filtersSelector = createSelector.bind(this)(
        [
            () => {
                let confirmedState = this.props.location.query.confirmed || [];
                if (!(confirmedState instanceof Array))
                    confirmedState = [confirmedState];
                return _.map(confirmedState, confirmed => confirmed === 'true');
            },
            () => this.props.store.getIn(['gradesTreeFilter']),
            () => this.props.store.getIn(['booksTreeFilter']),
            () => this.props.store.getIn(['chaptersTreeFilter']),
            () => this.props.store.getIn(['noteTypesTreeFilter']),
        ],
        confirmedState => [
            {
                field: 'confirmed',
                label: window.gettext('Confirmed'),
                component: <span>
                    <div
                        style={{
                            display: 'block',
                            float: 'right',
                            width: '10em',
                            cursor: 'pointer',
                        }}>
                        <Checkbox
                            checked={_.includes(confirmedState, true)}
                            onChange={this.confirmedChanged.bind(
                                this,
                                true,
                            )}>
                            {window.gettext('Confirmed')}
                        </Checkbox>
                    </div>
                    <div
                        style={{
                            display: 'block',
                            float: 'right',
                            width: '10em',
                            cursor: 'pointer',
                        }}>
                        <Checkbox
                            checked={_.includes(confirmedState, false)}
                            onChange={this.confirmedChanged.bind(
                                this,
                                false,
                            )}>
                            {window.gettext('Not confirmed')}
                        </Checkbox>
                    </div>
                </span>,
                selected: _.mapValues(
                    _.mapKeys(confirmedState, state => state ? 'True' : 'False'),
                    confirmed => confirmed ? window.gettext('Confirmed') : window.gettext('Not confirmed'),
                ),
            },
            {
                field: 'grade',
                label: window.gettext('Grade'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('gradesTreeFilter')}
                        readonly
                        header
                        resource='grade'
                        itemLabel='title'
                        label={window.gettext('Grade')}
                    />
                </div>,
                selected: this.props.store.getIn(['gradesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'grade',
                    this.props.store.getIn(['gradesTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'book',
                label: window.gettext('Book'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('booksTreeFilter')}
                        readonly
                        header
                        resource='book'
                        itemLabel={book => `${book.grade.title} - ${book.title}`}
                        filter={{
                            grade: this.props.store.getIn(['gradesTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('Book')}
                    />
                </div>,
                selected: this.props.store.getIn(['booksTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'book',
                    this.props.store.getIn(['booksTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'chapter',
                label: window.gettext('Chapter'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('chaptersTreeFilter')}
                        readonly
                        header
                        resource='chapter'
                        itemLabel={chapter => `${chapter.book.grade.title} - ${chapter.book.title} - ${chapter.caption}`}
                        filter={{
                            book: this.props.store.getIn(['booksTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('Chapter')}
                    />
                </div>,
                selected: this.props.store.getIn(['chaptersTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'chapter',
                    this.props.store.getIn(['chaptersTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'note_type',
                label: window.pgettext('note', 'Type'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('noteTypesTreeFilter')}
                        readonly
                        header
                        resource='note-type'
                        itemLabel='label'
                        label={window.pgettext('note', 'Type')}
                    />
                </div>,
                selected: this.props.store.getIn(['noteTypesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'note-type',
                    this.props.store.getIn(['noteTypesTreeFilter', 'elementId']),
                )),
            },
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'book', label: window.gettext('Book')},
        {name: 'national_id', label: window.gettext('national id')},
        {name: 'firstname', label: window.gettext('firstname')},
        {name: 'lastname', label: window.gettext('lastname')},
        {name: 'grade', label: window.gettext('Grade')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : this.props.store.getIn(['paginator', 'selected']).size === 0
                ? this.props.actions
                : _.concat(this.props.actions, [
                    {
                        label: window.gettext('Remove'),
                        action: async () => {
                            if (!window.confirm(window.interpolate(
                                window.gettext('Are you sure you wanna remove these %(count)s notes?'),
                                {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                true,
                            )))
                                return;
                            await this.context.store.dispatch(request({
                                path: '/note/?' + queryString.stringify({
                                    id: this.props.store.getIn(['paginator', 'selected']).keySeq().join(','),
                                }),
                                method: 'DELETE',
                            }));
                            this.context.store.dispatch([
                                ..._.map(
                                    this.props.store.getIn(['paginator', 'selected']).keySeq().toArray(),
                                    id => removeItem(
                                        id,
                                        this.props.store.getIn(['paginator', 'elementId']),
                                    ),
                                ),
                                clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                            ]);
                        },
                    },
                    {
                        label: window.gettext('Confirm'),
                        action: async () => {
                            if (!window.confirm(window.interpolate(
                                window.gettext('Are you sure you wanna confirm these %(count)s notes?'),
                                {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                true,
                            )))
                                return;
                            await this.context.store.dispatch(request({
                                path: '/note/',
                                body: this.props.store.getIn(['paginator', 'selected']).map((note, id) => ({
                                    id,
                                    'confirmed_body': note.get('body'),
                                    confirmed: true,
                                })).toArray(),
                                method: 'PATCH',
                            }));
                            this.context.store.dispatch([
                                clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                            ]);
                        },
                    },
                    {
                        label: window.gettext('Unconfirm'),
                        action: async () => {
                            if (!window.confirm(window.interpolate(
                                window.gettext('Are you sure you wanna unconfirm these %(count)s notes?'),
                                {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                true,
                            )))
                                return;
                            await this.context.store.dispatch(request({
                                path: '/note/',
                                body: this.props.store.getIn(['paginator', 'selected']).map((note, id) => ({
                                    id,
                                    confirmed: false,
                                })).toArray(),
                                method: 'PATCH',
                            }));
                            this.context.store.dispatch([
                                clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                            ]);
                        },
                    },
                ]),
    )

    violationStyle = {items: {itemsList: {table: {width: '100%', tableLayout: 'fixed'}}}}

    violationListFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: item => `${item.user.firstname} ${item.user.lastname}`, label: window.gettext('User')},
        {
            field: item => _.map(
                _.filter(
                    _.map(Array(4), (__, index) => index),
                    index => item.type & 1 << index,
                ),
                index => window.pgettext('violation', `item-${index}`),
            ).join(window.gettext(',') + ' '),
            label: window.gettext('Violation Items'),
        },
        {
            field: item => {
                const div = document.createElement('DIV');
                div.innerHTML = item.message;
                return div.innerText;
            },
            label: window.gettext('Message'),
            style: {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            },
        },
        {
            field: item => <div
                style={{
                    backgroundColor: item.checked
                        ? styles.successBackColor
                        : styles.warningBackColor,
                    color: item.checked
                        ? styles.successColor
                        : styles.warningColor,
                    borderColor: item.checked
                        ? styles.successBorderColor
                        : styles.warningBorderColor,
                    textAlign: 'center',
                }}>
                {item.checked
                    ? window.gettext('Checked')
                    : window.gettext('Not Checked')
                }
            </div>,
            label: '',
        },
    ]

    violationFiltersSelector = createSelector(
        [() => this.props.params.id],
        () => [
            {
                field: 'target',
                selected: {[['note', this.props.params.id].join(':')]: undefined},
            },
        ],
    )

    violationActionsSelector = createSelector(
        [
            () => this.props.readonly,
            () => this.props.store.getIn(['violations', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? []
            : this.props.store.getIn(['violations', 'selected']).size === 0
                ? []
                : [
                    {
                        label: window.gettext('Remove'),
                        action: () => {
                            if (!window.confirm(window.interpolate(
                                window.gettext('Are you sure you wanna remove these %(count)s violation reports?'),
                                {count: this.props.store.getIn(['violations', 'selected']).size.persian()},
                                true,
                            )))
                                return;
                            this.context.store.dispatch([
                                request({
                                    path: '/violation/?' + queryString.stringify({
                                        id: this.props.store.getIn(['violations', 'selected']).keySeq().join(','),
                                    }),
                                    method: 'DELETE',
                                }),
                                ..._.map(
                                    this.props.store.getIn(['violations', 'selected']).keySeq().toArray(),
                                    id => removeItem(
                                        id,
                                        this.props.store.getIn(['violations', 'elementId']),
                                    ),
                                ),
                                clearSelection(this.props.store.getIn(['violations', 'elementId'])),
                                paginatorRefresh(this.props.store.getIn(['violations', 'elementId'])),
                            ]);
                        },
                    },
                    {
                        label: window.gettext('Checked'),
                        action: () => {
                            if (!window.confirm(window.interpolate(
                                window.gettext('Are you sure you wanna check these %(count)s violation reports?'),
                                {count: this.props.store.getIn(['violations', 'selected']).size.persian()},
                                true,
                            )))
                                return;
                            this.context.store.dispatch([
                                request({
                                    path: '/violation/',
                                    body: this.props.store.getIn(['violations', 'selected']).keySeq().map(id => ({
                                        id,
                                        checked: true,
                                    })).toArray(),
                                    method: 'PATCH',
                                }),
                                clearSelection(this.props.store.getIn(['violations', 'elementId'])),
                                paginatorRefresh(this.props.store.getIn(['violations', 'elementId'])),
                            ]);
                        },
                    },
                ],
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    confirmedChanged(confirmed, event) {
        if (event)
            event.stopPropagation();
        let confirmedState = this.props.location.query.confirmed || [];
        if (!(confirmedState instanceof Array))
            confirmedState = [confirmedState];
        confirmedState = _.map(confirmedState, confirmed => confirmed === 'true');
        if (_.includes(confirmedState, confirmed)) {
            _.remove(confirmedState, s => s === confirmed);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, confirmed: confirmedState},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    confirmed: [confirmed],
                },
            }));
        }
    }

    tooltip(item) {
        const div = document.createElement('DIV');
        div.innerHTML = item.body;
        return div.innerText;
    }

    violationTooltip(item) {
        const div = document.createElement('DIV');
        div.innerHTML = item.message;
        return div.innerText;
    }

    render() {
        if (this.props.params.id)
            return <div>
                <div style={{width:  'calc(100% - 21.5em)'}}>
                    <Note
                        data={this.props.store.getIn(['paginator', 'data']).find(
                            item => item.get('id') === Number.parseInt(this.props.params.id),
                        ).toJS()}
                        editable
                        open
                        noteTypeTree={this.props.store.get('noteTypesTreeFilter')}
                        refresh={() => {
                            const path = this.context.store.getState().getIn(
                                ['routing', 'locationBeforeTransitions', 'pathname'],
                            );
                            this.context.store.dispatch([
                                push(path.split('/').slice(0, -2).join('/') + '/'),
                                paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                            ]);
                        }}
                    />
                </div>
                <PaginatedContainer
                    store={this.props.store.get('violations')}
                    resource='violation'
                    style={this.violationStyle}
                    listFields={this.violationListFields}
                    tooltip={this.violationTooltip}
                    title={window.gettext('Violation Reports')}
                    readonly
                    selectable
                    sidebar={false}
                    pageSize={30}
                    filters={this.violationFiltersSelector(this.props.params.id)}
                    actions={this.violationActionsSelector(this.props.store)}
                    buttonActions={this.props.actions}
                />
            </div>;
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='note'
            style={this.style}
            listFields={this.listFields}
            tooltip={this.tooltip}
            title={window.gettext('Notes')}
            selectable
            filters={this.filtersSelector(this.props.store, this.props.location)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.props.actions}
        />;
    }
}
